import { createContext } from 'react';
 
const GradientInfoContext = createContext();

export default GradientInfoContext;